export default {"src":"/_next/static/media/load-more-dark.c0539e52.svg","height":256,"width":256};